import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { DayGantt } from '../components/turnaround/DayGantt';
import { ReadinessBoard } from '../components/turnaround/ReadinessBoard';
import { TurnaroundReport } from '../components/turnaround/TurnaroundReport';
import { TemplateEditor } from '../components/turnaround/TemplateEditor';

export default function TurnaroundPage() {
    return (
        <div className="space-y-6" data-testid="turnaround-page">
            <div>
                <h1 className="text-4xl font-bold tracking-tight uppercase font-['Barlow_Condensed']" data-testid="turnaround-title">Turnaround</h1>
                <p className="text-muted-foreground mt-1">Rotación en plataforma por actividad: plan, registro real, demoras y análisis</p>
            </div>
            <Tabs defaultValue="day">
                <TabsList className="flex-wrap h-auto">
                    <TabsTrigger value="day" data-testid="ta-tab-day">Vista del día</TabsTrigger>
                    <TabsTrigger value="readiness" data-testid="ta-tab-readiness">Preparación</TabsTrigger>
                    <TabsTrigger value="report" data-testid="ta-tab-report">Reporte</TabsTrigger>
                    <TabsTrigger value="template" data-testid="ta-tab-template">Plantilla</TabsTrigger>
                </TabsList>
                <TabsContent value="day" className="mt-4"><DayGantt /></TabsContent>
                <TabsContent value="readiness" className="mt-4"><ReadinessBoard /></TabsContent>
                <TabsContent value="report" className="mt-4"><TurnaroundReport /></TabsContent>
                <TabsContent value="template" className="mt-4"><TemplateEditor /></TabsContent>
            </Tabs>
        </div>
    );
}
